import styles from "./CategoriesDropdown.module.scss";
import React from "react";
import {AppStaticDropdown} from "./AppStaticDropdown";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {DEFAULT_COLOR} from "./ColorBox";

export const CategoriesDropdown = ({value, onChange, categories, allowNoCategory = true}) => {
  const {t} = useTranslation("app");

  const noCategory = {
    id: null,
    name: t("category_name_unknown"),
    icon: "help_outline",
    color: DEFAULT_COLOR,
    active: true
  };

  let choices;

  if (allowNoCategory) {
    choices = [noCategory, ...categories.toSorted((a, b) => (a.groupName + a.name).localeCompare(b.groupName + b.name))];
  } else {
    choices = categories.toSorted((a, b) => (a.groupName + a.name).localeCompare(b.groupName + b.name));
  }

  return <AppStaticDropdown
    value={value}
    choices={choices}
    choiceValue={choice => choice.id}
    choiceLabel={choice => choice.name}
    choiceGroup="groupName"
    choiceDisplay={CategoryChoiceDisplay}
    onChange={onChange}
  />;
};

const CategoryChoiceDisplay = (choice, current) => {
  const [background, color] = choice.color.split("|");

  return <div className={styles.choiceCategory}>
    <div className={styles.categoryColor} style={{background}}>
      <span className="category-icon material-icons" style={{color}}>{choice.icon}</span>
    </div>
    <div className={styles.categoryName}>
      {current && choice.groupName ? choice.groupName + " / " + choice.name : choice.name}

      {!choice.active && <span className={clsx("material-icons", styles.inactiveIcon)}>visibility_off</span>}
    </div>
  </div>;
};
